/**
 * 分享配置
 * 包括：微信和QQ
 */
import { getSignature } from '@/api/login'
import utils from '@/utils/validator'
import { WX_QQ_CONFIG, appId } from '../constants'
import browser from './browser'

// 默认配置
const defaultConfig = {
  debug: false,
  params: {},
  updateSignature: false,
  ...WX_QQ_CONFIG,
}

// 微信分享类
class WXShare {
  constructor(opts = {}) {
    this.options = Object.assign({}, defaultConfig, opts)
    _init(this)
  }
  /**
   * 扩展配置对象: 用于页面切换路由重新获取分享签名或设置不同分享信息
   * @param {object} opts - 配置对象
   */
  setOptions(opts = {}) {
    Object.assign(this.options, opts)
    if (this.options.updateSignature) {
      _init(this)
    } else {
      this.share()
    }
  }
  /**
   * 注册微信分享方法
   */
  share() {
    const wx = window.wx
    const shareObj = this.options
    QQShare(shareObj)
    wx.ready(function() {
      const config = {
        title: shareObj.title,
        desc: shareObj.desc,
        link: shareObj.link,
        imgUrl: shareObj.imgUrl,
        trigger(res) {
          shareObj.trigger && shareObj.trigger(res)
        },
        complete(res) {
          shareObj.complete && shareObj.complete(res)
        },
        success(res = {}) {
          // ** 新版本这个回调代表设置成功，已非原来用户点击分享的回调 ** //
          // {"errMsg":"updateTimelineShareData:ok"}
          // 01:微信好友 02:微信朋友圈 03:QQ好友 04:QQ空间 05:新浪微博
          // 06:和飞信 07:复制链接 08:短信 99:其它
          res.platform = '99'
          if (res.errMsg) {
            var currentApi = res.errMsg.split(':')[0]
            switch (currentApi) {
              case 'onMenuShareTimeline':
                res.platform = '01'
                break
              case 'onMenuShareAppMessage':
                res.platform = '02'
                break
              case 'onMenuShareQQ':
                res.platform = '03'
                break
              case 'onMenuShareQZone':
                res.platform = '04'
                break
              case 'onMenuShareWeibo':
                res.platform = '05'
                break
              case 'updateAppMessageShareData':
                res.platform = '0103'
                break
              case 'updateTimelineShareData':
                res.platform = '0204'
                break
            }
          }
          shareObj.success && shareObj.success(res)
        },
        cancel(res) {
          shareObj.cancel && shareObj.cancel(res)
        },
        fail(res) {
          shareObj.fail && shareObj.fail(res)
        },
      }
      // 分享到腾讯微博
      wx.onMenuShareWeibo(config)
      if (wx.updateTimelineShareData) {
        // 新版本
        wx.updateTimelineShareData(config) // 分享到朋友圈及分享到QQ空间
        wx.updateAppMessageShareData(config) // 分享给朋友及分享到QQ
      } else {
        // 即将废弃版本
        wx.onMenuShareTimeline(config) // 分享到朋友圈
        wx.onMenuShareAppMessage(config) // 分享给朋友
        wx.onMenuShareQQ(config) // 分享到QQ
        wx.onMenuShareQZone(config) // 分享到QQ空间
      }
    })
  }
}

/**
 * 初始化分享
 * @param {object} target - 分享实例
 */
function _init(target) {
  const noncestr = utils.getUUID()
  const timestamp = Date.now() + ''
  getSignature({
    paramCode: 'WXGZH',
    noncestr,
    timeStamp: timestamp,
    url: window.location.href.split('#')[0],
  }).then(result => {
    const signature = result || ''
    const { options } = target
    window.wx.config({
      debug: !!options.debug,
      appId,
      timestamp,
      nonceStr: noncestr,
      signature,
      jsApiList: [
        'chooseWXPay',
        'updateTimelineShareData',
        'updateAppMessageShareData',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
      ],
    })
    target.share() // 注册分享方法
  })
}

/**
 * QQ分享设置
 * @param {object} shareObj - 配置对象
 */
export const QQShare = function(shareObj = {}) {
  let head = document.querySelector('head')
  let script = head.querySelector('script')
  let metaName = head.querySelector('[itemprop=name]')
  let metaImage = head.querySelector('[itemprop=image]')
  let metaDescription = head.querySelector('[itemprop=description]')
  if (!metaName) {
    metaName = document.createElement('meta')
    metaName.setAttribute('itemprop', 'name')
    head.insertBefore(metaName, script)
  }
  if (!metaImage) {
    metaImage = document.createElement('meta')
    metaImage.setAttribute('itemprop', 'image')
    head.insertBefore(metaImage, script)
  }
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    metaDescription.setAttribute('itemprop', 'description')
    head.insertBefore(metaDescription, script)
  }
  metaName.setAttribute('content', shareObj.title)
  metaImage.setAttribute('content', shareObj.imgUrl)
  metaDescription.setAttribute('content', shareObj.desc)
}

// 微信分享单例
let instance = null
export default function(opts = {}) {
  if (!instance && browser.isWeChat) {
    instance = new WXShare(opts)
  } else {
    QQShare(WX_QQ_CONFIG)
  }
  return instance
}
